const keywords = [
  {
    icon: "ri-scales-3-line",
    title: "道德困境",
    desc: "核心议题通常是「两难」而非「对错」。人物被放进相互冲突的责任里，任何选择都要付出代价。",
  },
  {
    icon: "ri-user-heart-line",
    title: "人物优先",
    desc: "议题服务于人物，而不是人物服务于议题。观众跟着一个具体的人，去经历他无法回避的处境。",
  },
  {
    icon: "ri-question-line",
    title: "不做判断",
    desc: "作品往往拒绝给出标准答案，把结论悬置在结尾，让观众带着问题离开银幕。",
  },
];

const compare = [
  {
    title: "欧洲的路径",
    icon: "ri-earth-line",
    points: [
      "从日常生活切入，把宏大议题收进家庭与个体",
      "偏爱开放结局，道德判断留给观众",
      "作者导演色彩强，节奏克制、留白明显",
    ],
    tone: "primary" as const,
  },
  {
    title: "好莱坞的路径",
    icon: "ri-film-line",
    points: [
      "常用类型片框架，情节驱动强、冲突外显",
      "倾向给出清晰立场与情感宣泄点",
      "更强调因果闭环与人物弧光的完成",
    ],
    tone: "secondary" as const,
  },
];

export default function ConceptSection() {
  return (
    <section id="concept" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-8 lg:gap-14">
          <div>
            <span className="text-xs md:text-sm font-label tracking-[0.3em] text-primary-600 uppercase">Introduction</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              什么是「伦理电影」？
            </h2>
          </div>
          <div className="text-sm md:text-base leading-relaxed text-foreground-700 space-y-4">
            <p>
              在电影研究里，伦理电影并不是一个严格的类型标签，而更像一种关注方向：它把镜头对准人在道德困境中的处境，
              讨论责任、欲望、罪责与选择。相较于用善恶对立推动情节，它更愿意承认——每个选择都同时包含合理与代价。
            </p>
            <p>
              欧洲是这类作品的重要土壤。从意大利新写实主义到法国新浪潮，再到德国与东欧的作者电影，
              一代代创作者把社会、历史与家庭的重量，放进一个普通人的一天里。<strong className="text-foreground-900 font-semibold">看电影，也是练习如何面对没有标准答案的问题。</strong>
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {keywords.map((k) => (
            <article
              key={k.title}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-200 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                <i className={`${k.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{k.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{k.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {compare.map((col) => (
            <div
              key={col.title}
              className={`p-5 md:p-6 rounded-lg border ${
                col.tone === "primary"
                  ? "bg-primary-50 border-primary-200"
                  : "bg-secondary-50 border-secondary-200"
              }`}
            >
              <div className="flex items-center gap-2.5 mb-4">
                <span
                  className={`w-9 h-9 flex items-center justify-center rounded-md ${
                    col.tone === "primary"
                      ? "bg-primary-500 text-background-50"
                      : "bg-secondary-500 text-background-50"
                  }`}
                >
                  <i className={`${col.icon} text-base`} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{col.title}</h3>
              </div>
              <ul className="space-y-2.5">
                {col.points.map((p) => (
                  <li key={p} className="flex gap-2.5 text-sm leading-relaxed text-foreground-700">
                    <i className="ri-check-line mt-0.5 text-primary-500 shrink-0" aria-hidden="true"></i>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}